export const environment = {
  production: "{production}",
  syncfusionKey: "{syncfusionKey}",
  apiBaseUrl: "{apiBaseUrl}",
  paymentMaxWaitTime: 2,
  paymentGetCCTStatusInterval: 10
};
